import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ComponentModel } from 'src/app/models/maintenance/component.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ComponentService {

  constructor(private _httpClient: HttpClient) { }

  createComponent(componentModel: ComponentModel): Observable<ComponentModel> {
    return this._httpClient.post<ComponentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.component.CreateAsync}`,
      componentModel);
  }

  deleteComponent(componentId: number): Observable<ComponentModel> {
    return this._httpClient.delete<ComponentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.component.DeleteAsync}/${componentId}`);
  }

  deleteSomeDetails(componentIds: number[]): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.component.DeleteSomeDetailsAsync}`,
      componentIds);
  }

  getComponentsByRoutineAsync(maintenanceRoutineId: number): Observable<ComponentModel[]> {
    return this._httpClient.get<ComponentModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.component.GetComponentsByRoutineAsync}/${maintenanceRoutineId}`);
  }

  getAllComponentWithPaginationAsync(maintenanceRoutineId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('maintenanceRoutineId', maintenanceRoutineId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.component.GetAllComponentWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getComponentByCode(maintenanceRoutineId: number, code: number): Observable<ComponentModel> {
    return this._httpClient.get<ComponentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.component.GetByCodeAsync}/${maintenanceRoutineId}/${code}`)
  }

  getComponentById(id: number): Observable<ComponentModel> {
    return this._httpClient.get<ComponentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.component.GetByIdAsync}/${id}`);
  }

  getColumnsAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.component.GetColumnsAsync}`);
  }

  updateComponent(componentModel: ComponentModel): Observable<ComponentModel> {
    return this._httpClient.put<ComponentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.component.UpdateAsync}`,
      componentModel);
  }
}
